import Vue from 'vue'
import {
    Button,
    Form,
    Field,
    Radio,
    RadioGroup,
    Checkbox,
    Icon,
    Picker,
    DatetimePicker,
    Cell,
    CellGroup,
    Tabs,
    Tab,
    Dialog,
    Popup,
    Tabbar,
    TabbarItem,
    List,
    PullRefresh,
    NavBar,
    Circle,
    Rate,
    Empty,
    Stepper
} from 'vant'

Vue.use(Button)
    .use(Form)
    .use(Field)
    .use(Radio)
    .use(RadioGroup)
    .use(Checkbox)
    .use(Icon)
    .use(Picker)
    .use(DatetimePicker)
    .use(Cell)
    .use(CellGroup)
    .use(Tabs)
    .use(Tab)
    .use(Dialog)
    .use(Popup)
    .use(Tabbar)
    .use(TabbarItem)
    .use(List)
    .use(PullRefresh)
    .use(NavBar)
    .use(Circle)
    .use(Rate)
    .use(Empty)
    .use(Stepper)